export default {
  builder: {
    heroTitlePre: 'GPAX Builder:',
    heroTitlePost: 'Interopera tus sistemas rápida y eficientemente',
    interoperateTitle: 'Interopera con:',
    interoperateDesc: 'GPAX Builder interopera con sistemas sin requerir cambios.',
    dbTitle: 'Bases de datos:',
    dbText: 'Oracle, SQL Server, Sybase, MongoDB, otros.',
    legacyTitle: 'Sistema legado:',
    legacyText: 'Cobol, RPG, AS/400, Series A, otros.',
    appsTitle: 'Aplicaciones:',
    appsText: 'Desktop, web, Api, SOA, WSE, SAP, otros.',
    devicesTitle: 'Dispositivos:',
    devicesText: 'Drones, sistemas de control de acceso, PDAs, ATM.',
    filesTitle: 'Archivos:',
    filesText: 'MS Excel, CSV, SFTP, FTP, otros.',
    complementTitle: 'Complementa con:',
    complementDesc: 'GPAX Builder tiene componentes especializados que aceleran tu proceso de desarrollo.',
    complement1: 'Geoviewer y minería de datos.',
    complement2: 'Monitoreo de recursos y Cliente Universal.',
    complement3: 'Trazabilidad y gobernanza.',
    complement4: 'Indicadores, reportes y automatización (RPA).',
    complement5: 'Diseñador visual de procedimientos.',
    benefit1Title: 'Interoperabilidad',
    benefit1Desc: 'Creando un ecosistema digital para la organización.',
    benefit2Title: 'Desarrollo en tiempo real',
    benefit2Desc: 'Co-crea nuevas soluciones junto con los usuarios dueños del proceso.',
    benefit3Title: 'Plataforma low-code',
    benefit3Desc: 'No requiere conocimiento de lenguajes existentes.',
    benefit4Title: 'Confiabilidad y estabilidad',
    benefit4Desc: 'De tus aplicaciones en una nueva plataforma digital.',
    benefit5Title: 'Estándar BPMN 2.0',
    benefit5Desc: 'Para modelar procesos.',
    benefit6Title: 'Alto impacto',
    benefit6Desc: 'En corto tiempo.',
    servicesTitle: 'Servicios',
    service1: 'Orquestamos procesos de negocio.',
    service2: 'Intermediación e integración de aplicaciones.',
    service3: 'Desarrollo de aplicaciones de inicio a fin.',
    service4: 'Minería de datos.',
    service5: 'Reducción y consolidación de datos.',
    service6: 'Conectividad de última milla y RPA.',
    service7: 'Creación y monitoreo de indicadores con notificaciones.',
    service8: 'Migración y análisis de datos.',
    storiesTitle: 'Historias de éxito',
    tabMunicipality: 'Municipalidad',
    tabBpo: 'BPO Call Center',
    tabFinancial: 'Institución Financiera',
    problem: 'Problema',
    solution: 'Solución',
    result: 'Resultado',
    stories: {
      municipality: {
        problem: [
          { label: '12 sistemas', text: 'aislados entre sí atendiendo trámites ciudadanos.' },
          { label: '48h', text: 'de espera promedio para resolver una solicitud de un vecino.' },
        ],
        solution: [
          { label: '', text: 'Se integran las plataformas municipales con GPAX Builder, sin modificarlas.' },
          { label: '', text: 'El trámite se orquesta con el diseñador visual de procedimientos.' },
          { label: '', text: 'El ciudadano sigue su solicitud desde un único portal.' },
        ],
        result: [
          { label: '3 meses', text: 'para poner en marcha el nuevo flujo de atención.' },
          { label: '80%', text: 'de reducción en los tiempos de respuesta al ciudadano.' },
        ],
      },
      bpo: {
        problem: [
          { label: '9 pantallas', text: 'que el agente debía abrir para atender una sola llamada.' },
          { label: '7 min', text: 'de tiempo promedio por llamada.' },
        ],
        solution: [
          { label: '', text: 'Se unifican los sistemas del cliente en una pantalla única del agente.' },
          { label: '', text: 'GPAX Builder valida la identidad y el estado del cliente en tiempo real.' },
          { label: '', text: 'Las campañas se conectan vía API y SFTP con los componentes especializados.' },
        ],
        result: [
          { label: '4 semanas', text: 'de implementación junto al equipo de operaciones.' },
          { label: '45%', text: 'de reducción en el tiempo promedio de llamada.' },
        ],
      },
      financial: {
        problem: [
          { label: '600 TPS', text: '(solicitudes de transacción) de sus cobradores externos.' },
          { label: '5 TPS', text: '(solicitudes de transacción) capacidad en su sistema actual.' },
        ],
        solution: [
          { label: '', text: 'Se crea un caché virtual de datos del sistema actual.' },
          { label: '', text: 'Cada transacción de cobrador se valida y aprueba contra caché.' },
          { label: '', text: 'Otro proceso se sincroniza con el sistema actual.' },
        ],
        result: [
          { label: '100h', text: 'para desarrollar la solución.' },
          { label: '6h', text: 'después de la hora pico el sistema está sincronizado.' },
        ],
      },
    },
    ctaTitle: '¿Quieres saber más sobre nosotros?',
    contact: 'Contáctanos',
  },
};